import React, { useState, useEffect } from "react";
import { useUser } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import CartProductList from "./CartProductList";
import { useCart } from "services/CartService";
import { ShoppingBasket } from "lucide-react";
import { Button } from "components/ui/button";
import { Droppable } from "../Drop/Droppable";

const Cart = (props: { disabledCart?: boolean }) => {
  const [total, setTotal] = useState(0);
  const [delivery, setDelivery] = useState(7);
  const { isSignedIn } = useUser();
  const navigate = useNavigate();
  const { getCart } = useCart();

  useEffect(() => {
    const cartItems = getCart().filter(product => product.selected === true);
    const cartTotal = cartItems.reduce((sum, item) => sum + (item.price ? item.price : 0) * (item.quantity * item.minimum), 0);
    
    setTotal(cartTotal);
    setDelivery(7);
  }, [getCart]);

  const navigateToTunnel = () => {
    navigate('/boutique/checkout');
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className='flex justify-between items-center m-3 py-2'>
        <h3 className="font-bold text-primary text-md">Votre panier</h3>
        <ShoppingBasket className='text-primary' />
      </div>
      
      <Droppable disabled={props.disabledCart}>
        <CartProductList />
      </Droppable>

      <div className='px-3 pb-3 mt-3 bg-white'>
        <div className="grid grid-cols-[auto_auto] items-center justify-between my-2">
          <span className="text-md mr-2" style={{ color: "#637381" }}>Total : </span>
          <span className="text-lg font-semibold">{total.toFixed(2)}€ HT</span>
        </div>
        {total < 100 && <p className="text-right pb-2 text-sm text-accent">Minimum de 100€ de commande non atteint</p>}
        <div className="grid grid-cols-[auto_auto] items-center justify-between my-2">
          <span className="text-sm mr-2 text-gray-500">livraison : </span>
          <span className="text-sm font-semibold text-gray-500">{total > 499.99 ? 0 : delivery}€ HT</span>
        </div>
        <hr className="mb-2" />
        {!isSignedIn ? (
          <Button href="/connexion" className="w-full">
            Se connecter pour commander
          </Button>
        ) : (
          <Button
            disabled={getCart().filter(product => product.selected === true).length === 0 || total < 100}
            onClick={navigateToTunnel}
            className={`w-full mb-2 ${getCart().filter(product => product.selected === true).length === 0 ? 'opacity-50 cursor-not-allowed' : 'opacity-100'}`}
          >
            Commander
          </Button>
        )}
      </div>
    </>
  );
};

export default Cart;